import { useApi } from "@shopexperts/shared";
import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";

export function useRedirects() {
  const api = useApi();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['admin', 'redirects'],
    queryFn: () => api.admin.redirects.list({ query: { limit: 50 } }),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  const redirects = computed(() => data.value?.data || []);

  return {
    redirects,
    isLoading,
    error,
    refetch,
  };
}

